import { css } from '../../styles/theme';
import { IButtonStyles } from '../Button/ButtonStyled';
import { rem } from 'polished';

export const StylesOVGB = css<IButtonStyles>`
    padding: ${rem(10)} ${rem(65)};
    
    &:hover {
        transition: all .3s ease;
    }
    
    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: 4px solid ${({ theme }) => theme.colors.primary};
            &:hover {
                background: ${({ theme }) => theme.colors.primaryHover};
                color: ${({ theme }) => theme.colors.primary};
            }
        `}
    
    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: 4px solid ${({ theme }) => theme.colors.blue1};
            background: ${({ theme }) => theme.colors.blue1};
            &:hover {
                background: ${({ theme }) => theme.colors.secondaryHover};
                color: ${({ theme }) => theme.colors.blue1};
            }
        `}
    
    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
        `}
    
    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            border-color: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.white};
        `}
`;
